import ic_alcohol_ball from '../assets/icon/ic_alcohol_ball.webp';
import ic_undercast_padding from '../assets/icon/ic_undercast_padding.webp';
import ic_cotton_ball from '../assets/icon/ic_cotton_ball.webp';
import ic_cotton_roll from '../assets/icon/ic_cotton_roll.webp';
import ic_cotton_pad from '../assets/icon/ic_cotton_pad.webp';
import ic_cotton_buds from '../assets/icon/ic_cotton_buds.webp';
import ic_wet_wipes from '../assets/icon/ic_wet_wipes.webp';
import icon_good_product from "../assets/icon/good-product.svg";
import icon_professional from "../assets/icon/professional.svg";
import icon_standard from "../assets/icon/standard.svg";
import icon_alliance from '../assets/icon/alliance.svg';
import icon_eco_friendly from '../assets/icon/eco_friendly.svg';
import icon_one_stop from '../assets/icon/one_stop.svg';
import cotton_banner from "../assets/image/product/pure_cotton_banner.webp";
import fabric_banner from "../assets/image/product/fabric_banner.webp";
import flag_en from "../assets/image/home/flag_en.webp";
import flag_th from "../assets/image/home/flag_th.webp";
import cotton_card_banner from "../assets/image/product/cotton_card_banner.webp";
import wet_wipes_card_banner from "../assets/image/product/wet_wipes_card_banner.webp";
import map1th from "../assets/image/contact/map_1_th.webp";
import map1en from "../assets/image/contact/map_1_en.webp";
import map2th from "../assets/image/contact/map_2_th.webp";
import map2en from "../assets/image/contact/map_2_en.webp";
import img_baby_aliz from "../assets/image/customer/img_baby_aliz.webp";
import img_wipedia from "../assets/image/customer/img_wipedia.webp";
import img_banne from "../assets/image/customer/img_banne.webp";
import img_d_nee from "../assets/image/customer/img_d_nee.webp";
import img_evergreen from "../assets/image/customer/img_evergreen.webp";
import img_happy_hippo from "../assets/image/customer/img_happy_hippo.webp";
import img_happy_price from "../assets/image/customer/img_happy_price.webp";
import img_karisma from "../assets/image/customer/img_karisma.webp";
import img_lison from "../assets/image/customer/img_lison.webp";
import img_nurse from "../assets/image/customer/img_nurse.webp";
import img_procare from "../assets/image/customer/img_procare.webp";
import img_shell from "../assets/image/customer/img_shell.webp";
import img_smart_r from "../assets/image/customer/img_smart_r.webp";
import img_central from "../assets/image/customer/img_central.webp";
import img_aeon from "../assets/image/customer/img_aeon.webp";
import cotton_medical_undercast_padding_menu from "../assets/image/home/cotton_medical_undercast_padding_menu.webp";
import cotton_medical_cotton_ball_menu from "../assets/image/home/cotton_medical_cotton_ball_menu.webp";
import cotton_medical_cotton_roll_menu from "../assets/image/home/cotton_medical_cotton_roll_menu.webp";
import cotton_medical_cotton_pad_menu from "../assets/image/home/cotton_medical_cotton_pad_menu.webp";
import cotton_medical_alcohol_ball_menu from "../assets/image/home/cotton_medical_alcohol_ball_menu.webp";
import cotton_general_cotton_pad_menu from "../assets/image/home/cotton_general_cotton_pad_menu.webp";
import cotton_general_cotton_ball_menu from "../assets/image/home/cotton_general_cotton_ball_menu.webp";
import cotton_general_cotton_roll_menu from "../assets/image/home/cotton_general_cotton_roll_menu.webp";
import cotton_general_cotton_buds_menu from "../assets/image/home/cotton_general_cotton_buds_menu.webp";
import wet_wipes_medical_alcohol_ball_menu from "../assets/image/home/wet_wipes_medical_alcohol_ball_menu.webp";
import wet_wipes_general_wet_wipes_menu from "../assets/image/home/wet_wipes_general_wet_wipes_menu.webp";
import wet_wipes_special_wet_wipes_menu from "../assets/image/home/wet_wipes_special_wet_wipes_menu.webp";
import cotton_medical_undercast_padding_list from "../assets/image/product/cotton_medical_undercast_padding_list.webp";
import cotton_medical_cotton_ball_list from "../assets/image/product/cotton_medical_cotton_ball_list.webp";
import cotton_medical_cotton_roll_list from "../assets/image/product/cotton_medical_cotton_roll_list.webp";
import cotton_medical_cotton_pad_list from "../assets/image/product/cotton_medical_cotton_pad_list.webp";
import cotton_medical_alcohol_ball_list from "../assets/image/product/cotton_medical_alcohol_ball_list.webp";
import cotton_general_cotton_pad_list from "../assets/image/product/cotton_general_cotton_pad_list.webp";
import cotton_general_cotton_ball_list from "../assets/image/product/cotton_general_cotton_ball_list.webp";
import cotton_general_cotton_roll_list from "../assets/image/product/cotton_general_cotton_roll_list.webp";
import cotton_general_cotton_buds_list from "../assets/image/product/cotton_general_cotton_buds_list.webp";
import wet_wipes_medical_alcohol_ball_list from "../assets/image/product/wet_wipes_medical_alcohol_ball_list.webp";
import wet_wipes_general_wet_wipes_list from "../assets/image/product/wet_wipes_general_wet_wipes_list.webp";
import wet_wipes_special_wet_wipes_list from "../assets/image/product/wet_wipes_special_wet_wipes_list.webp";
import logo_th from "../assets/image/logo_th.svg";
import logo_en from "../assets/image/logo_en.svg";

export const logo_image = {
    'logo_th': logo_th,
    'logo_en': logo_en,
}

export const customers =
    {
        'cotton': [
            {
                'title': 'lison',
                'image': img_karisma,
            },
            {
                'title': 'lison',
                'image': img_lison,
            },
            {
                'title': 'evergreen',
                'image': img_evergreen,
            },
            {
                'title': 'd_nee',
                'image': img_d_nee,
            },
            {
                'title': 'central',
                'image': img_smart_r,
            },
            {
                'title': 'central',
                'image': img_central,
            },
            {
                'title': 'happy_price',
                'image': img_happy_price,
            },
            {
                'title': 'aeon',
                'image': img_aeon,
            },
            {
                'title': 'happy_hippo',
                'image': img_happy_hippo,
            },
            {
                'title': 'banne',
                'image': img_banne,
            },
            {
                'title': 'nurse',
                'image': img_nurse,
            },
            {
                'title': 'baby_aliz',
                'image': img_baby_aliz,
            },
            {
                'title': 'wipedia',
                'image': img_wipedia,
            }
        ],
        'wet_wipes': [
            {
                'title': 'lion',
                'image': img_karisma,
            },
            {
                'title': 'central',
                'image': img_smart_r,
            },
            {
                'title': 'procare',
                'image': img_procare,
            },
            {
                'title': 'shell',
                'image': img_shell,
            },
            {
                'title': 'wipedia',
                'image': img_wipedia,
            }
        ]
    }

export const productMenuImages = {
    'cotton_1': cotton_medical_undercast_padding_menu,
    'cotton_2': cotton_medical_cotton_ball_menu,
    'cotton_3': cotton_medical_cotton_roll_menu,
    'cotton_4': cotton_medical_cotton_pad_menu,
    'cotton_5': cotton_medical_alcohol_ball_menu,
    'cotton_6': cotton_general_cotton_pad_menu,
    'cotton_7': cotton_general_cotton_ball_menu,
    'cotton_8': cotton_general_cotton_roll_menu,
    'cotton_9': cotton_general_cotton_buds_menu,
    'wet_wipes_10': wet_wipes_medical_alcohol_ball_menu,
    'wet_wipes_11': wet_wipes_general_wet_wipes_menu,
    'wet_wipes_12': wet_wipes_special_wet_wipes_menu,
}

export const productListImages = {
    'cotton_1': cotton_medical_undercast_padding_list,
    'cotton_2': cotton_medical_cotton_ball_list,
    'cotton_3': cotton_medical_cotton_roll_list,
    'cotton_4': cotton_medical_cotton_pad_list,
    'cotton_5': cotton_medical_alcohol_ball_list,
    'cotton_6': cotton_general_cotton_pad_list,
    'cotton_7': cotton_general_cotton_ball_list,
    'cotton_8': cotton_general_cotton_roll_list,
    'cotton_9': cotton_general_cotton_buds_list,
    'wet_wipes_10': wet_wipes_medical_alcohol_ball_list,
    'wet_wipes_11': wet_wipes_general_wet_wipes_list,
    'wet_wipes_12': wet_wipes_special_wet_wipes_list,
}

export const products = [
    {
        'id': 1,
        'type': 'cotton',
        'category': 'product_category_cotton_wool',
        'banner': cotton_banner,
        'groups': [
            {
                'name': 'product_cotton_wool_medical_name',
                'items': [
                    {
                        'id': 1,
                        'icon': ic_undercast_padding,
                        'title': 'product_cotton_wool_medical_undercast_padding_title',
                        'content': 'product_cotton_wool_medical_undercast_padding_description',
                        'feature': 'feature_cotton_wool_undercast_padding',
                        'package': {
                            'title': 'cotton_wool_medical_undercast_padding_package_title',
                            items: [
                                {
                                    'detail': 'cotton_wool_medical_undercast_padding_package_1',
                                    'unit': 'cotton_wool_medical_undercast_padding_package_1_unit',
                                },
                                {
                                    'detail': 'cotton_wool_medical_undercast_padding_package_2',
                                    'unit': 'cotton_wool_medical_undercast_padding_package_2_unit',
                                },
                                {
                                    'detail': 'cotton_wool_medical_undercast_padding_package_3',
                                    'unit': 'cotton_wool_medical_undercast_padding_package_3_unit',
                                },
                                {
                                    'detail': 'cotton_wool_medical_undercast_padding_package_4',
                                    'unit': 'cotton_wool_medical_undercast_padding_package_4_unit',
                                },
                            ],
                        }
                    },
                    {
                        'id': 2,
                        'icon': ic_cotton_ball,
                        'title': 'product_cotton_wool_medical_cotton_ball_title',
                        'content': 'product_cotton_wool_medical_cotton_ball_description',
                        'feature': 'feature_cotton_wool_medical_cotton_ball',
                        'package': {
                            'title': 'cotton_wool_medical_cotton_ball_package_title',
                            items: [
                                {
                                    'detail': 'cotton_wool_medical_cotton_ball_package_1',
                                    'unit': 'cotton_wool_medical_cotton_ball_package_1_unit',
                                },
                                {
                                    'detail': 'cotton_wool_medical_cotton_ball_package_2',
                                    'unit': 'cotton_wool_medical_cotton_ball_package_2_unit',
                                },
                                {
                                    'detail': 'cotton_wool_medical_cotton_ball_package_3',
                                    'unit': 'cotton_wool_medical_cotton_ball_package_3_unit',
                                },
                            ],
                        }
                    },
                    {
                        'id': 3,
                        'icon': ic_cotton_roll,
                        'title': 'product_cotton_wool_medical_cotton_roll_title',
                        'content': 'product_cotton_wool_medical_cotton_roll_description',
                        'feature': 'feature_cotton_wool_medical_cotton_roll',
                        'package': {
                            'title': 'cotton_wool_medical_cotton_roll_package_title',
                            items: [
                                {
                                    'detail': 'cotton_wool_medical_cotton_roll_package_1',
                                    'unit': 'cotton_wool_medical_cotton_roll_package_1_unit',
                                }
                            ]
                        }
                    },
                    {
                        'id': 4,
                        'icon': ic_cotton_pad,
                        'title': 'product_cotton_wool_medical_cotton_pad_title',
                        'content': 'product_cotton_wool_medical_cotton_pad_description',
                        'feature': 'feature_cotton_wool_medical_cotton_pad',
                        'package': {
                            'title': 'cotton_wool_medical_cotton_pad_package_title',
                            items: [
                                {
                                    'detail': 'cotton_wool_medical_cotton_pad_package_1',
                                    'unit': 'cotton_wool_medical_cotton_pad_package_1_unit',
                                },
                                {
                                    'detail': 'cotton_wool_medical_cotton_pad_package_2',
                                    'unit': 'cotton_wool_medical_cotton_pad_package_2_unit',
                                },
                                {
                                    'detail': 'cotton_wool_medical_cotton_pad_package_3',
                                    'unit': 'cotton_wool_medical_cotton_pad_package_3_unit',
                                },
                                {
                                    'detail': 'cotton_wool_medical_cotton_pad_package_4',
                                    'unit': 'cotton_wool_medical_cotton_pad_package_4_unit',
                                },
                            ],
                        }
                    },
                    {
                        'id': 5,
                        'icon': ic_alcohol_ball,
                        'title': 'product_cotton_wool_medical_alcohol_ball_title',
                        'content': 'product_cotton_wool_medical_alcohol_ball_description',
                        'feature': 'feature_cotton_wool_medical_alcohol_ball',
                        'package': {
                            'title': 'cotton_wool_medical_alcohol_ball_package_title',
                            items: [
                                {
                                    'detail': 'cotton_wool_medical_alcohol_ball_package_1',
                                    'unit': 'cotton_wool_medical_alcohol_ball_package_1_unit',
                                }
                            ]
                        }
                    }
                ]
            },
            {
                'name': 'product_cotton_wool_general_name',
                'items': [
                    {
                        'id': 6,
                        'icon': ic_cotton_pad,
                        'title': 'product_cotton_wool_general_cotton_pad_title',
                        'content': 'product_cotton_wool_general_cotton_pad_description',
                        'feature': 'feature_cotton_wool_general_cotton_pad',
                        'package': {
                            'title': 'cotton_wool_general_cotton_pad_package_title',
                            items: [
                                {
                                    'detail': 'cotton_wool_general_cotton_pad_package_1',
                                    'unit': 'cotton_wool_general_cotton_pad_package_1_unit',
                                },
                                {
                                    'detail': 'cotton_wool_general_cotton_pad_package_2',
                                    'unit': 'cotton_wool_general_cotton_pad_package_2_unit',
                                },
                                {
                                    'detail': 'cotton_wool_general_cotton_pad_package_3',
                                    'unit': 'cotton_wool_general_cotton_pad_package_3_unit',
                                },
                                {
                                    'detail': 'cotton_wool_general_cotton_pad_package_4',
                                    'unit': 'cotton_wool_general_cotton_pad_package_4_unit',
                                },
                                {
                                    'detail': 'cotton_wool_general_cotton_pad_package_5',
                                    'unit': 'cotton_wool_general_cotton_pad_package_5_unit',
                                },
                                {
                                    'detail': 'cotton_wool_general_cotton_pad_package_6',
                                    'unit': 'cotton_wool_general_cotton_pad_package_6_unit',
                                },
                                {
                                    'detail': 'cotton_wool_general_cotton_pad_package_7',
                                    'unit': 'cotton_wool_general_cotton_pad_package_7_unit',
                                },
                            ]
                        }
                    },
                    {
                        'id': 7,
                        'icon': ic_cotton_ball,
                        'title': 'product_cotton_wool_general_cotton_ball_title',
                        'content': 'product_cotton_wool_general_cotton_ball_description',
                        'feature': 'feature_cotton_wool_general_cotton_ball',
                        'package': {
                            'title': 'cotton_wool_general_cotton_ball_package_title',
                            items: [
                                {
                                    'detail': 'cotton_wool_general_cotton_ball_package_1',
                                    'unit': 'cotton_wool_general_cotton_ball_package_1_unit',
                                },
                                {
                                    'detail': 'cotton_wool_general_cotton_ball_package_2',
                                    'unit': 'cotton_wool_general_cotton_ball_package_2_unit',
                                },
                                {
                                    'detail': 'cotton_wool_general_cotton_ball_package_3',
                                    'unit': 'cotton_wool_general_cotton_ball_package_3_unit',
                                },
                                {
                                    'detail': 'cotton_wool_general_cotton_ball_package_4',
                                    'unit': 'cotton_wool_general_cotton_ball_package_4_unit',
                                },
                            ]
                        }
                    },
                    {
                        'id': 8,
                        'icon': ic_cotton_roll,
                        'title': 'product_cotton_wool_general_cotton_roll_title',
                        'content': 'product_cotton_wool_general_cotton_roll_description',
                        'feature': 'feature_cotton_wool_general_cotton_roll',
                        'package': {
                            'title': 'cotton_wool_general_cotton_roll_package_title',
                            items: [
                                {
                                    'detail': 'cotton_wool_general_cotton_roll_package_1',
                                    'unit': 'cotton_wool_general_cotton_roll_package_1_unit',
                                }
                            ]
                        }
                    },
                    {
                        'id': 9,
                        'icon': ic_cotton_buds,
                        'title': 'product_cotton_wool_general_cotton_buds_title',
                        'content': 'product_cotton_wool_general_cotton_buds_description',
                        'feature': 'feature_cotton_wool_general_cotton_buds',
                        'package': {
                            'title': 'cotton_wool_general_cotton_buds_package_title',
                            items: [
                                {
                                    'detail': 'cotton_wool_general_cotton_buds_package_1',
                                    'unit': 'cotton_wool_general_cotton_buds_package_1_unit',
                                },
                                {
                                    'detail': 'cotton_wool_general_cotton_buds_package_2',
                                    'unit': 'cotton_wool_general_cotton_buds_package_2_unit',
                                },
                                {
                                    'detail': 'cotton_wool_general_cotton_buds_package_3',
                                    'unit': 'cotton_wool_general_cotton_buds_package_3_unit',
                                },
                            ]
                        }
                    }
                ],
            }],
        'customers': customers.cotton,
    },
    {
        'id': 2,
        'type': 'wet_wipes',
        'category': 'product_category_wet_wipes',
        'banner': fabric_banner,
        'groups': [
            {
                'name': 'product_wet_wipes_medical_name',
                'items': [
                    {
                        'id': 10,
                        'icon': ic_alcohol_ball,
                        'title': 'product_wet_wipes_medical_alcohol_ball_title',
                        'content': 'product_wet_wipes_medical_alcohol_ball_description',
                        'feature': 'feature_wet_wipes_medical_alcohol_ball',
                        'package': {
                            'title': 'wet_wipes_medical_alcohol_pad_package_title',
                            items: [
                                {
                                    'detail': 'wet_wipes_medical_alcohol_pad_package_1',
                                    'unit': 'wet_wipes_medical_alcohol_pad_package_1_unit',
                                },
                                {
                                    'detail': 'wet_wipes_medical_alcohol_pad_package_2',
                                    'unit': 'wet_wipes_medical_alcohol_pad_package_2_unit',
                                },
                                {
                                    'detail': 'wet_wipes_medical_alcohol_pad_package_3',
                                    'unit': 'wet_wipes_medical_alcohol_pad_package_3_unit',
                                },
                            ]
                        }
                    }
                ]
            },
            {
                'name': 'product_wet_wipes_general_name',
                'items': [
                    {
                        'id': 11,
                        'icon': ic_wet_wipes,
                        'title': 'product_wet_wipes_general_wet_wipes_title',
                        'content': 'product_wet_wipes_general_wet_wipes_description',
                        'feature': 'feature_wet_wipes_general_wet_wipes',
                        'package': {
                            'title': 'wet_wipes_general_wet_wipes_package_title',
                            items: [
                                {
                                    'detail': 'wet_wipes_general_wet_wipes_package',
                                    'unit': 'wet_wipes_general_wet_wipes_package_1_unit',
                                },
                                {
                                    'detail': 'wet_wipes_general_wet_wipes_package',
                                    'unit': 'wet_wipes_general_wet_wipes_package_2_unit',
                                },
                                {
                                    'detail': 'wet_wipes_general_wet_wipes_package',
                                    'unit': 'wet_wipes_general_wet_wipes_package_3_unit',
                                },
                                {
                                    'detail': 'wet_wipes_general_wet_wipes_package',
                                    'unit': 'wet_wipes_general_wet_wipes_package_4_unit',
                                },
                                {
                                    'detail': 'wet_wipes_general_wet_wipes_package',
                                    'unit': 'wet_wipes_general_wet_wipes_package_5_unit',
                                },
                                {
                                    'detail': 'wet_wipes_general_wet_wipes_package',
                                    'unit': 'wet_wipes_general_wet_wipes_package_6_unit',
                                },
                                {
                                    'detail': 'wet_wipes_general_wet_wipes_package',
                                    'unit': 'wet_wipes_general_wet_wipes_package_7_unit',
                                },
                                {
                                    'detail': 'wet_wipes_general_wet_wipes_package',
                                    'unit': 'wet_wipes_general_wet_wipes_package_8_unit',
                                },
                                {
                                    'detail': 'wet_wipes_general_wet_wipes_package',
                                    'unit': 'wet_wipes_general_wet_wipes_package_9_unit',
                                },
                            ]
                        }
                    },
                ]
            },
            {
                'name': 'product_wet_wipes_special_name',
                'items': [
                    {
                        'id': 12,
                        'icon': ic_wet_wipes,
                        'title': 'product_wet_wipes_special_wet_wipes_title',
                        'content': 'product_wet_wipes_special_wet_wipes_description',
                        'feature': 'feature_wet_wipes_special_wet_wipes',
                        'package': {
                            'title': 'wet_wipes_special_wet_wipes_package_title',
                            items: [
                                {
                                    'detail': 'wet_wipes_special_wet_wipes_package',
                                    'unit': 'wet_wipes_special_wet_wipes_package_1_unit',
                                },
                                {
                                    'detail': 'wet_wipes_special_wet_wipes_package',
                                    'unit': 'wet_wipes_special_wet_wipes_package_2_unit',
                                },
                                {
                                    'detail': 'wet_wipes_special_wet_wipes_package',
                                    'unit': 'wet_wipes_special_wet_wipes_package_3_unit',
                                },
                                {
                                    'detail': 'wet_wipes_special_wet_wipes_package',
                                    'unit': 'wet_wipes_special_wet_wipes_package_4_unit',
                                },
                                {
                                    'detail': 'wet_wipes_special_wet_wipes_package',
                                    'unit': 'wet_wipes_special_wet_wipes_package_5_unit',
                                },
                                {
                                    'detail': 'wet_wipes_special_wet_wipes_package',
                                    'unit': 'wet_wipes_special_wet_wipes_package_6_unit',
                                },
                                {
                                    'detail': 'wet_wipes_special_wet_wipes_package',
                                    'unit': 'wet_wipes_special_wet_wipes_package_7_unit',
                                },
                                {
                                    'detail': 'wet_wipes_special_wet_wipes_package',
                                    'unit': 'wet_wipes_special_wet_wipes_package_8_unit',
                                },
                                {
                                    'detail': 'wet_wipes_special_wet_wipes_package',
                                    'unit': 'wet_wipes_special_wet_wipes_package_9_unit',
                                },
                            ]
                        }
                    }
                ]
            }
        ],
        'customers': customers.wet_wipes,
    }
]

export const points = [
    {
        "icon": icon_one_stop,
        "title": "one_stop_title",
        "content": "one_stop_content",
    },
    {
        "icon": icon_professional,
        "title": "professional_title",
        "content": "professional_content",
    },
    {
        "icon": icon_eco_friendly,
        "title": "eco_friendly_title",
        "content": "eco_friendly_content",
    },
    {
        "icon": icon_good_product,
        "title": "good_product_title",
        "content": "good_quality_content",
    },
    {
        "icon": icon_standard,
        "title": "standard_title",
        "content": "standard_content",
    },
    {
        "icon": icon_alliance,
        "title": "alliance_title",
        "content": "alliance_content",
    },
];

export const maps = {
    'map_1_th': map1th,
    'map_2_th': map2th,
    'map_1_en': map1en,
    'map_2_en': map2en,
}

export const address = [
    {
        'name': 'contact_address_name_1',
        'description': 'contact_address_description_1',
        'number': '+662 819 2230',
        'mail': 'info@siamcottonwool.co.th',
        'time': 'contact_office_time_1',
        'image': 'map_hq',
        'map_link': 'https://maps.app.goo.gl/fWbkNb33E5o9LjP96',
    },
    {
        'name': 'contact_address_name_2',
        'description': 'contact_address_description_2',
        'number': '+6661 405 0955',
        'mail': 'info@siamcottonwool.co.th',
        'time': 'contact_office_time_2',
        'image': 'map_branch',
        'map_link': 'https://maps.app.goo.gl/WnZLzJU9LEDzYaVS6',
    }
]

export const languages = [
    {
        'key': 'th',
        'name': 'ภาษาไทย',
        'image': flag_th,
    },
    {
        'key': 'en',
        'name': 'English',
        'image': flag_en,
    }
];

export const product_cards = [
    {
        'image': cotton_card_banner,
        'link': 'cotton',
        'title': 'product_category_cotton_wool',
        'content': 'product_card_content_cotton_wool',
    },
    {
        'image': wet_wipes_card_banner,
        'link': 'wet_wipes',
        'title': 'product_category_wet_wipes',
        'content': 'product_card_content_wet_wipes',
    }
]

export const subject_options = [
    {
        'value': 'oem_inquiries',
        'label': 'subject_option_1',
    },
    {
        'value': 'product_information',
        'label': 'subject_option_2',
    },
    {
        'value': 'partner_ship',
        'label': 'subject_option_3',
    },
    {
        'value': 'ordering_and_sales',
        'label': 'subject_option_4',
    },
    {
        'value': 'customer_service',
        'label': 'subject_option_5',
    },
    {
        'value': 'product_issues',
        'label': 'subject_option_6',
    },
    {
        'value': 'general',
        'label': 'subject_option_7',
    }
]

export const timeline = [
    {
        'year': '01_year',
        'text': '01_title',
    },
    {
        'year': '02_year',
        'text': '02_title',
    },
    {
        'year': '03_year',
        'text': '03_title',
    },
    {
        'year': '04_year',
        'text': '04_title',
    },
    {
        'year': '05_year',
        'text': '05_title',
    },
    {
        'year': '06_year',
        'text': '06_title',
    },
    {
        'year': '07_year',
        'text': '07_title',
    },
    {
        'year': '08_year',
        'text': '08_title',
    },
    {
        'year': '09_year',
        'text': '09_title',
    },
    {
        'year': '10_year',
        'text': '10_title',
    }
]
